import transport from '../transport';
export default transport;


//////////////////
// WEBPACK FOOTER
// /home/vsts/work/1/s/node_modules/@splitsoftware/splitio/es/services/auth/index.js
// module id = 2887
// module chunks = 1